import React from "react";
import { Button } from "components/ui/button";
import { Badge } from "components/ui/badge";
import { Popover, PopoverTrigger, PopoverContent } from "components/ui/popover";
import { ArrowUp, ArrowDown, ArrowUpDown, RotateCcw } from "lucide-react";

const sortFields = [
    { key: "name", label: "שם" },
    { key: "product", label: "מוצר" },
    { key: "date", label: "תאריך" },
];

// Sort applies immediately on click — no separate "apply" step, since it's a
// single low-cardinality choice (3 fields x 2 directions), unlike the
// multi-field filter form which stays a Dialog with explicit apply/reset.
const OrdersSortPopover = ({ sort = { sortField: "", sortOrder: "" }, onSortChange }) => {
    const activeField = sort.sortField && sort.sortField !== "all" ? sort.sortField : "";
    const activeOrder = sort.sortOrder && sort.sortOrder !== "all" ? sort.sortOrder : "";
    const activeLabel = sortFields.find((f) => f.key === activeField)?.label;

    const onFieldClick = (fieldKey) => {
        if (fieldKey === activeField) {
            onSortChange?.({ sortField: fieldKey, sortOrder: activeOrder === "asc" ? "desc" : "asc" });
            return;
        }
        onSortChange?.({ sortField: fieldKey, sortOrder: fieldKey === "date" ? "desc" : "asc" });
    };

    const clearSort = () => onSortChange?.({ sortField: "", sortOrder: "" });

    return (
        <Popover modal={false}>
            <PopoverTrigger asChild>
                <Button variant="secondary" className="gap-2" aria-label="מיון">
                    {activeField ? (
                        activeOrder === "asc" ? (
                            <ArrowUp className="h-4 w-4" />
                        ) : (
                            <ArrowDown className="h-4 w-4" />
                        )
                    ) : (
                        <ArrowUpDown className="h-4 w-4" />
                    )}
                    <span className="hidden sm:inline">{activeField ? `מיון: ${activeLabel}` : "מיון"}</span>
                </Button>
            </PopoverTrigger>

            <PopoverContent dir="rtl" align="end" sideOffset={8} className="space-y-3">
                <div className="flex items-center justify-between">
                    <p className="text-sm font-medium">מיון לפי</p>

                    {activeField && (
                        <Button
                            type="button"
                            variant="ghost"
                            size="sm"
                            onClick={clearSort}
                            className="h-7 gap-1 px-2 text-muted-foreground"
                        >
                            <RotateCcw className="h-3.5 w-3.5" />
                            נקה
                        </Button>
                    )}
                </div>

                <div className="flex flex-wrap gap-2">
                    {sortFields.map((f) => {
                        const isActive = f.key === activeField;

                        return (
                            <button
                                key={f.key}
                                type="button"
                                onClick={() => onFieldClick(f.key)}
                                className="focus:outline-none"
                                aria-pressed={isActive}
                            >
                                <Badge
                                    variant={isActive ? "default" : "secondary"}
                                    className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm"
                                >
                                    <span>{f.label}</span>
                                    {isActive ? (
                                        activeOrder === "asc" ? (
                                            <ArrowUp className="h-3.5 w-3.5" />
                                        ) : (
                                            <ArrowDown className="h-3.5 w-3.5" />
                                        )
                                    ) : (
                                        <ArrowDown className="h-3.5 w-3.5 opacity-25" />
                                    )}
                                </Badge>
                            </button>
                        );
                    })}
                </div>
            </PopoverContent>
        </Popover>
    );
};

export default OrdersSortPopover;
